import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div>
      {/* <!-- Footer Start --> */}
      <div
        className="container-fluid bg-dark text-light mt-5 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div className="container-fluid bg-dark text-light mt-5 pt-5 pb-3">
          <div className="container">
            <div className="row gy-5 gx-5 align-items-start">
              {/* Left Column: About Section */}
              <div className="col-lg-4 col-md-6 footer-about">
                <div className="bg-primary text-center p-4 rounded h-100 d-flex flex-column align-items-center justify-content-center">
                  <Link to="/" className="navbar-brand mb-3">
                    <img
                      src="assets/img/mympp.png"
                      alt="MyMPP Logo"
                      height="60"
                      className="d-block mx-auto"
                    />
                  </Link>
                 <p className="text-light mb-0">
  Smart, data-driven sales and lead solutions that help your business grow with measurable results.
</p>

                </div>
              </div>

              {/* Right Column: Contact + Links */}
              <div className="col-lg-8 col-md-6">
                <div className="row gy-4 gx-5">
                  {/* Contact Info */}
                  <div className="col-lg-6 col-md-12">
                    <div className="section-title section-title-sm position-relative pb-3 mb-4">
                      <h3 className="text-light mb-0">Get In Touch</h3>
                    </div>

                    <div className="d-flex align-items-start mb-3">
                      <i className="bi bi-geo-alt text-primary me-3 fs-5"></i>
                      <p className="mb-0">Mumbai, Maharashtra</p>
                    </div>

                    <div className="d-flex align-items-start mb-3">
                      <i className="bi bi-envelope-open text-primary me-3 fs-5"></i>
                      <a
                        href="mailto:info@myeasytaxpropartners.com"
                        className="text-light text-decoration-none"
                      >
                        info@myeasytaxpropartners.com
                      </a>
                    </div>

                    <div className="d-flex align-items-start mb-3">
                      <i className="bi bi-telephone text-primary me-3 fs-5"></i>
                      <div>
                        <a
                          href="tel:+918850322403"
                          className="text-light text-decoration-none d-block"
                        >
                          +91 8850322403
                        </a>
                        <a
                          href="tel:+919167437326"
                          className="text-light text-decoration-none d-block"
                        >
                          +91 9167437326
                        </a>
                      </div>
                    </div>

                    <div className="d-flex mt-4">
                      <a
                        className="btn btn-primary btn-square me-2"
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-twitter fw-normal"></i>
                      </a>
                      <a
                        className="btn btn-primary btn-square me-2"
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook-f fw-normal"></i>
                      </a>
                      <a
                        className="btn btn-primary btn-square me-2"
                        href="https://linkedin.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin-in fw-normal"></i>
                      </a>
                      <a
                        className="btn btn-primary btn-square"
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-instagram fw-normal"></i>
                      </a>
                    </div>
                  </div>

                  {/* Quick Links */}
                  <div className="col-lg-6 col-md-12">
                    <div className="section-title section-title-sm position-relative pb-3 mb-4">
                      <h3 className="text-light mb-0">Quick Links</h3>
                    </div>
                    <div className="link-animated d-flex flex-column">
                      <Link className="text-light mb-2" to="/">
                        <i className="bi bi-arrow-right text-primary me-2"></i>
                        Home
                      </Link>
                      <Link className="text-light mb-2" to="/about">
                        <i className="bi bi-arrow-right text-primary me-2"></i>
                        About Us
                      </Link>
                      <Link className="text-light mb-2" to="/services">
                        <i className="bi bi-arrow-right text-primary me-2"></i>
                        Our Services
                      </Link>
                      <Link className="text-light" to="/contact">
                        <i className="bi bi-arrow-right text-primary me-2"></i>
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container-fluid text-white"
        style={{ background: "#061429" }}
      >
        <div className="container text-center">
          <div className="row justify-content-end">
            <div className="col-lg-8 col-md-6">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: "75px" }}
              >
                <p className="mb-0">
                  &copy;{" "}
                  <a className="text-white border-bottom" href="#">
                    Your Site Name
                  </a>
                  . All Rights Reserved. Designed by{" "}
                  <a
                    className="text-white border-bottom"
                    href="https://htmlcodex.com"
                  >
                    HTML Codex
                  </a>
                </p>
                <br />
                Distributed By:{" "}
                <a
                  className="border-bottom"
                  href="https://themewagon.com"
                  target="_blank"
                >
                  ThemeWagon
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Footer End --> */}

      {/* <!-- Back to Top --> */}
      <a
        href="#"
        className="btn btn-lg btn-primary btn-lg-square rounded back-to-top"
      >
        <i className="bi bi-arrow-up"></i>
      </a>
    </div>
  );
}
